import newhttp from '~/http/new';

export default ({
  state: {
    data: [],
    filters: {},
    perProfile: 0,
    page: 1,
    pages: 0,
  },

  getters: {
    requestData(state, getters, rootState, rootGetters) {
      const { filters, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        fromDate: filters.fromDate ? filters.fromDate : undefined,
        toDate: filters.toDate ? filters.toDate : undefined,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },

    SET_PER_PROFILE(state, data) {
      state.perProfile = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const response = await newhttp.get('v1/p2p/external-user-requisite', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });

      const { Items, Total } = response.data;

      commit('SET_DATA', Items);
      if (Total) {
        const itemsPerPage = rootGetters['common/itemsPerPage'];
        const pages = Math.ceil(Total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async loadBookingSettings({ getters, commit }, data) {
      const response = await newhttp.get('v1/p2p/booking-settings', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });

      const { MaxRequisiteBundlesPerProfile } = response.data;

      commit('SET_PER_PROFILE', MaxRequisiteBundlesPerProfile);
    },

    async updateSettings(__store, data) {
      const response = await newhttp.put('v1/p2p/booking-settings', data);
      return response.data.Result.Success;
    },

    async deleteRelation(__store, id) {
      const response = await newhttp.delete('v1/p2p/external-user-requisite', { params: { id } });
      return response.data;
    },
  },

  namespaced: true,
});
